export default __webpack_public_path__ + "assets/img/login.01d015f4679b84627220ed1a208f602b.svg";